import { useEffect } from 'react';

const FlipBook = ({ pdfUrl, onClose }) => {
  useEffect(() => {
    window.open(pdfUrl, '_blank');
    onClose();
  }, [pdfUrl, onClose]);

  return null;
};

export default FlipBook;
